
const initialState = {
  loading: false,
  payoutListByFY: [],
  error: "",
};

const payoutListByFYReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PAYOUT_LIST_DATA_SUCCESS":
      return {
        ...state,
        payoutListByFY: action.payload,
        loading: false,
      };

    case "PAYOUT_LIST_DATA_ERROR":
      return {
        ...state,
        error: action.payload,
        payoutListByFY: [],
        loading: false,
      };

    default:
      return state;
  }
};

export default payoutListByFYReducer;